import React from 'react';
import ListItem from 'components/ListItem';
import { numberToOrdinal } from 'utils/formatter/number-to-ordinal';

export interface OwnProps {
    orderIntoTank: number;
}

type Props = OwnProps;

export default class SummaryProductOrderIntoTankListItem extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { orderIntoTank } = this.props;

        return (
            <ListItem
                description="Order into tank"
                value={numberToOrdinal(orderIntoTank)}
            />
        );
    }
}
